module.exports = __webpack_public_path__ + "static/media/sarpanch.ceacd01f.png";